<template>
	<div class="list-group">
		<div class="list-item list-item-choices"
			v-for="(item, index) in services"
			:key="index"
			:class="{'active': isServiceChoosen(item)}"
			@click="onChooseService(item)">
			<div class="list-item-content">
				<div class="title">{{item.name}}</div>
				<div class="sub-title">
					{{item.hostname}}
				</div>
			</div>
			<div class="list-item-actions">
				<div class="checkbox-round" @click="onChooseService(item)">
					<input type="checkbox" id="checkbox"
						:checked="isServiceChoosen(item)"/>
					<label for="checkbox"></label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['value', 'services'],
	methods: {
		isServiceChoosen(item) {
			return this.value === item._id;
		},
		onChooseService(item) {
			this.$emit('input', item._id);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/parts/service/ChooseServiceList.vue